import { render } from "./bidTemplates.vue?vue&type=template&id=ae367bd6&scoped=true"
import script from "./bidTemplates.vue?vue&type=script&lang=js"
export * from "./bidTemplates.vue?vue&type=script&lang=js"

import "./bidTemplates.vue?vue&type=style&index=0&id=ae367bd6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae367bd6"]])

export default __exports__